import React from 'react';
import Icon from 'components/ui/element/Icon';

const NotAuthorizedTemplate = ({formatMessage}) => (
    <div className="no-authorized-template">
        <h1>{formatMessage({id: 'title.serviceNotFound.service'}, {service: 'Smart Monitoring'})}</h1>
        <p>{formatMessage({id: 'notAuthorized.smartmonitoring.description'})}</p>
        <ul>
            <li>{formatMessage({id: 'notAuthorized.smartmonitoring.option1'})}</li>
            <li>{formatMessage({id: 'notAuthorized.smartmonitoring.option2'})}</li>
            <li>{formatMessage({id: 'notAuthorized.smartmonitoring.option3'})}</li>
            <li>{formatMessage({id: 'notAuthorized.smartmonitoring.option4'})}</li>
        </ul>
        <div className="no-authorized-template__contact">
            <h1><Icon key={'envelope'} name={'envelope'} /> {formatMessage({id: 'label.contacts.contact'})}</h1>
            <p>{formatMessage({id: 'notAuthorized.contact'})}</p>
            <ul>
                <li><a href="mailto:Solutions.EMS.Spain@eu.equinix.com">Solutions.EMS.Spain@eu.equinix.com</a></li>
            </ul>
        </div>
    </div>
);

module.exports = NotAuthorizedTemplate;



// WEBPACK FOOTER //
// ./src/routes/no-authorized-templates/smartmonitoring.js